export function getEntries<K, T>(object: Record<string, T>) {
  return Object.entries(object) as unknown as [K, T][]
}
